import { NiceModalHandler } from '@ebay/nice-modal-react';
import { Button } from '@mui/material';
import classNames from 'classnames';
import { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { implog } from '@/api/implog';
import { IconMyGoldSimple, RoundRs } from '@/components/icons/icons';
import showNiceModal from '@/components/nice-modal';
import FreeWithdrawInfoModal from '@/pages/game/components/modal-free-withdraw';
import VipWithdrawInfoModal from '@/pages/game/components/modal-vip-withdraw';
import { modalStore } from '@/stores/modal';
import globalStore from '@/stores/store';
import { removeTrailingZeros, toFixed } from '@/utils/utils';

import styles from './styles.module.less';

const WithdrawScoreModal = (modal: NiceModalHandler) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { initialState, initialFreeWithdrawInfo } = globalStore;
  const { vippoint } = initialState;
  const { score_free, score } = initialFreeWithdrawInfo;
  const freeCash = useMemo(() => {
    /** 免费提款额
     * i. 用户充值前，展示身金余额
     * ii. 用户充值后，展示免费提款额
     */
    if (vippoint > 0) {
      return removeTrailingZeros(toFixed(score_free));
    }
    return score;
  }, [vippoint, score, score_free]);
  const walletCash = useMemo(() => {
    /** 游戏钱包余额
     *i. 用户充值前，展示为 0
     *ii. 用户充值后，展示身金余额
     */
    if (vippoint > 0) {
      return removeTrailingZeros(toFixed(score));
    }
    return 0;
  }, [vippoint, score]);
  useEffect(() => {
    implog('modal_withdraw_coin_show');
  }, []);
  return (
    <div className={styles.main}>
      <div className={styles.content}>
        <div className={styles['content-header']}>
          Total balance{' '}
          <span
            className={styles['content-header-label-question']}
            onClick={() => {
              implog('modal_w_coin_w_help_click');
              showNiceModal(
                {
                  closable: {
                    hideClose: true
                  },
                  maskClosable: true,
                  top: '2.6rem',
                  render: modal => (
                    <div
                      style={{
                        padding: '0.4rem 0.4rem 0.3rem',
                        fontSize: '0.32rem',
                        lineHeight: '0.6rem',
                        textAlign: 'center'
                      }}
                    >
                      This is your total balance, which mainly comes from recharges and various bonuses.
                      <div style={{ display: 'flex' }}>
                        <Button
                          className={classNames(styles.btn, 'global_button_succes')}
                          sx={{
                            width: '2.8rem',
                            fontSize: '0.32rem',
                            height: '0.8rem',
                            borderRadius: '0.4rem',
                            textTransform: 'none',
                            margin: '0.78rem auto auto'
                          }}
                          variant="text"
                          onClick={() => {
                            modal?.hide();
                          }}
                        >
                          Ok
                        </Button>
                      </div>
                    </div>
                  )
                },
                'free-withdraw-help-modal'
              );
            }}
          >
            ?
          </span>
        </div>
        <div className={styles['content-retirar']}>
          <div className={styles['content-retirar-label']}>
            <RoundRs className={styles['content-retirar-icon']} />
            {walletCash}
          </div>
          <div
            className={styles['content-retirar-btn']}
            onClick={() => {
              implog('modal_w_coin_w_click');

              if (vippoint > 0) {
                navigate('/withdraw');
                modal?.hide();
                return;
              }
              showNiceModal(
                {
                  closable: {
                    hideClose: true
                  },
                  top: '2.6rem',
                  maskClosable: true,
                  render: VipWithdrawInfoModal
                },
                'vip-withdraw-info-modal'
              );
            }}
          >
            Withdraw
          </div>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles['content-header']}>
          Free bonus{' '}
          <span
            className={styles['content-header-label-question']}
            onClick={() => {
              implog('modal_w_coin_w_free_help_click');
              showNiceModal(
                {
                  closable: {
                    hideClose: true
                  },
                  maskClosable: true,
                  top: '2.6rem',
                  render: modal => (
                    <div
                      style={{
                        padding: '0.4rem 0.4rem 0.3rem',
                        fontSize: '0.32rem',
                        lineHeight: '0.6rem',
                        textAlign: 'center'
                      }}
                    >
                      {vippoint > 0
                        ? 'Free Bonus is the reward you receive as a free player. Deposit & complete tasks to withdraw it.'
                        : `Free Bonus is the reward you receive as a free player. Deposit any amounts to withdraw it.`}
                      <div style={{ display: 'flex' }}>
                        <Button
                          className={classNames(styles.btn, 'global_button_succes')}
                          sx={{
                            width: '2.8rem',
                            fontSize: '0.32rem',
                            height: '0.8rem',
                            borderRadius: '0.4rem',
                            textTransform: 'none',
                            margin: '0.78rem auto auto'
                          }}
                          variant="text"
                          onClick={() => {
                            modal?.hide();
                          }}
                        >
                          Ok
                        </Button>
                      </div>
                    </div>
                  )
                },
                'free-withdraw-help-modal'
              );
            }}
          >
            ?
          </span>
        </div>
        <div className={styles['content-retirar']}>
          <div className={styles['content-retirar-label']}>
            <IconMyGoldSimple className={styles['content-retirar-icon']} /> {freeCash}
          </div>
          <div
            className={styles['content-retirar-btn']}
            onClick={() => {
              implog('modal_w_coin_w_free_click');
              if (vippoint > 0) {
                navigate(globalStore.getFreeWithdrawPath());
                modal?.hide();
                return;
              }
              showNiceModal(
                {
                  closable: {
                    hideClose: true
                  },
                  maskClosable: true,
                  top: '2.6rem',
                  render: FreeWithdrawInfoModal
                },
                'free-withdraw-info-modal'
              );
            }}
          >
            Withdraw
          </div>
        </div>
      </div>
      <Button
        className={classNames(vippoint > 0 ? undefined : styles.btn, 'global_button_succes')}
        sx={{
          width: '2.8rem',
          fontSize: '0.32rem',
          height: '0.8rem',
          borderRadius: '0.4rem',
          marginTop: '0.1rem',
          textTransform: 'none'
        }}
        variant="text"
        onClick={async () => {
          implog('modal_w_coin_recharge_click');
          if (location?.pathname === '/recharge') {
            modalStore.openFirstRecharge();
          } else {
            navigate('/recharge');
          }
          modal?.hide();
        }}
      >
        Deposit
      </Button>
    </div>
  );
};

export default WithdrawScoreModal;
